import { useContext, useEffect } from 'react'
import { getForm } from '../../services/api/cms'
import { WagtailBlockProps } from '../../services/api/types'
import { SiteContext } from '../../services/context/SiteContext'
import { Col, Container, Row, Section } from '../../styles/grid.styles'
import * as S from './Brochure.styled'

export interface ImageAndTextContentProps extends WagtailBlockProps {
  value: {
    title: string
    image: string
    content: string
    form?: string
  }
}

const ImageAndTextContent = (props: ImageAndTextContentProps) => {
  const { setFormBrochure } = useContext(SiteContext)
  const { title, image, content, form } = props.value

  useEffect(() => {
    if (!form) return

    getForm(null, { slug: form }).then((formRes) => {
      if (formRes?.results?.length > 0) {
        setFormBrochure && setFormBrochure({ ...formRes.results[0] })
      }
    })

    // formBrochure lives in the app-level SiteContext, so clear it on
    // unmount or it keeps overriding the header CTA after navigating away
    return () => setFormBrochure && setFormBrochure(undefined)
  }, [form])

  return (
    <Section>
      <Container size='lg'>
        <Row itemsCenter gutter={10}>
          {image && (
            <Col md={6}>
              <S.Image src={image} alt={title} />
            </Col>
          )}
          <Col md={6}>
            <S.Info>
              {title && <S.Title>{title}</S.Title>}
              <S.Content dangerouslySetInnerHTML={{ __html: content }} />
            </S.Info>
          </Col>
        </Row>
      </Container>
    </Section>
  )
}
export default ImageAndTextContent
